import { render, staticRenderFns } from "./SaleOrderInfo.vue?vue&type=template&id=ec8c3d44&scoped=true&"
import script from "./SaleOrderInfo.vue?vue&type=script&lang=js&"
export * from "./SaleOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderInfo.vue?vue&type=style&index=0&id=ec8c3d44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8c3d44",
  null
  
)

export default component.exports